import { SpeechBubbleFill24Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { HStack, Tooltip } from "shared/components/Spor";

type CodeAndCommentProps = {
  code: string | null;
  comment: string | null;
};

const CodeAndComment: FC<CodeAndCommentProps> = ({ code, comment }) => (
  <HStack>
    <p>{code}</p>
    {comment?.replace(/^\s*$/, "")?.length && (
      <Tooltip hasArrow label={comment} placement="top">
        <SpeechBubbleFill24Icon aria-label="Kommentar" />
      </Tooltip>
    )}
  </HStack>
);

export default CodeAndComment;
